import axios from '../axios'


// 添加储蓄收支明细
export const addSavingDetail = data => {
    return axios({
        url: '/api/saving/detail/add',
        method: 'post',
        data
    })
}

// 查询所有储蓄收支明细
export const queryAllSavingDetail = () => {
    return axios({
        url: '/api/saving/queryAllSavingDetail',
        method: 'post',
    })
}

// 查询总储蓄金额
export const querySavingTotal = () => {
    return axios({
        url: '/api/saving/querySavingTotal',
        method: 'post',
    })
}

// 删除储蓄收支明细
export const deleteSavingDetailById = data => {
    return axios({
        url: '/api/saving/deleteSavingDetailById',
        method: 'post',
        data
    })
}

// 按照月份统计过去半年每月支出的求和
export const sumByMonthThePastHalfYear = data => {
    return axios({
        url: '/api/saving/sumByMonthThePastHalfYear',
        method: 'post',
        data
    })
}
